import { render, staticRenderFns } from "./CustomerPricePopup.vue?vue&type=template&id=f8095a82&"
import script from "./CustomerPricePopup.vue?vue&type=script&lang=js&"
export * from "./CustomerPricePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports